var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSourceSelection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.558,
    x2: 367.388,
    y1: 69.674,
    y2: 308.503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0268b4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.81,
    x2: 251.81,
    xlinkHref: "#lg1",
    y1: 246.917,
    y2: 302.795
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.702,
    x2: 347.114,
    xlinkHref: "#lg1",
    y1: 103.331,
    y2: 63.676
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.541,
    x2: 303.013,
    xlinkHref: "#lg1",
    y1: 394.517,
    y2: 289.989
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.601,
    x2: 294.772,
    y1: 208.416,
    y2: 302.588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.179,
    x2: 199.179,
    y1: 334.971,
    y2: 345.958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.711,
    x2: 177.711,
    xlinkHref: "#lg2",
    y1: 319.164,
    y2: 349.462
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.002,
    x2: 266.255,
    xlinkHref: "#lg2",
    y1: 343.609,
    y2: 476.862
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.659,
    x2: 221.659,
    y1: 466.704,
    y2: 504.997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.017,
    x2: 284.017,
    y1: 537.187,
    y2: 460.665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f46700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.829,
    x2: 288.736,
    y1: 331.395,
    y2: 380.301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ebac5"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.685,
    x2: 312.685,
    xlinkHref: "#lg3",
    y1: 381.939,
    y2: 430.485
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.685,
    x2: 312.685,
    y1: 455.837,
    y2: 488.594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.882,
    x2: 327.882,
    xlinkHref: "#lg3",
    y1: 454.889,
    y2: 470.48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m353.763 65.734c-13.197 0-25.901 2.109-37.801 5.993-12.73-41.529-51.372-71.727-97.071-71.727-56.065 0-101.515 45.45-101.515 101.515 0 8.101.954 15.978 2.747 23.53-47.846 3.373-85.616 43.251-85.616 91.956 0 50.916 41.276 92.192 92.192 92.192h227.063c67.23 0 121.73-54.5 121.73-121.73s-54.5-121.729-121.729-121.729z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.218 228.477c5.65 45.5 44.452 80.716 91.482 80.716h227.063c52.838 0 97.805-33.667 114.64-80.716z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.03 187.469c0 4.938.297 9.804.871 14.588-4.579.645-9.261.973-14.014.973-56.066 0-101.509-45.453-101.509-101.519 0-56.056 45.443-101.508 101.509-101.508 45.699 0 84.35 30.2 97.073 71.729-48.721 15.888-83.93 61.699-83.93 115.737z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m353.763 309.194c19.079 0 37.13-4.393 53.204-12.217l-138.314-138.295-.041-.062c-5.945-9.008-19.163-9.008-25.108 0l-58.697 88.935c-4.889 7.407-2.217 16.635 4.364 20.924l35.634 35.919v4.796z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.446 158.619-58.697 88.935c-6.6 10.001.572 23.328 12.554 23.328h27.444v71.878c0 7.997 6.483 14.481 14.481 14.481h33.545c7.997 0 14.481-6.483 14.481-14.481v-71.878h27.444c11.982 0 19.154-13.327 12.554-23.328l-58.697-88.935c-5.946-9.008-19.164-9.008-25.109 0z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240.954 359.292h-83.551v-23.796c0-7.885 6.392-14.278 14.278-14.278h54.995c7.885 0 14.278 6.392 14.278 14.278z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.486 359.292h-83.551v-23.796c0-7.885 6.392-14.278 14.278-14.278h54.995c7.885 0 14.278 6.392 14.278 14.278z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.747 348.319v-12.823c0-7.885-6.392-14.278-14.278-14.278h-54.995c-7.885 0-14.278 6.392-14.278 14.278v154.164c0 11.234 9.107 20.34 20.34 20.34h176.244c11.234 0 20.34-9.107 20.34-20.34v-114.787c0-11.234-9.107-20.34-20.34-20.34h-106.82c-3.431-.001-6.213-2.782-6.213-6.214z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.197 467.167v22.492c0 11.234 9.107 20.34 20.34 20.34h176.244c11.234 0 20.34-9.107 20.34-20.34v-22.492z",
    fill: "url(#SVGID_9_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m330.121 489.66v-32.491h-92.208v11.188c0 3.299 1.586 6.218 4.018 8.069l33.55 33.574h34.3c11.234 0 20.34-9.107 20.34-20.34z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m337.245 477.43h-90.258c-5.595 0-10.131-4.536-10.131-10.131v-151.505c0-3.645 2.955-6.6 6.6-6.6h114.511c3.645 0 6.6 2.955 6.6 6.6v134.312c.001 15.091-12.232 27.324-27.322 27.324z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m349.218 489.403h-90.258c-5.595 0-10.131-4.536-10.131-10.131v-151.505c0-3.645 2.955-6.6 6.6-6.6h114.511c3.645 0 6.6 2.955 6.6 6.6v134.313c.001 15.09-12.232 27.323-27.322 27.323z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m360.957 362.54h-86.719c-2.73 0-4.943-2.213-4.943-4.943v-6.74c0-2.73 2.213-4.943 4.943-4.943h86.719c2.73 0 4.943 2.213 4.943 4.943v6.74c-.001 2.731-2.214 4.943-4.943 4.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.957 390.398h-86.719c-2.73 0-4.943-2.213-4.943-4.943v-6.74c0-2.73 2.213-4.943 4.943-4.943h86.719c2.73 0 4.943 2.213 4.943 4.943v6.74c-.001 2.73-2.214 4.943-4.943 4.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.923 418.256h-42.685c-2.73 0-4.943-2.213-4.943-4.943v-6.74c0-2.73 2.213-4.943 4.943-4.943h42.685c2.73 0 4.943 2.213 4.943 4.943v6.74c0 2.73-2.213 4.943-4.943 4.943z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m248.829 442.329v36.942c0 5.595 4.536 10.131 10.131 10.131h90.258c15.09 0 27.323-12.233 27.323-27.323v-19.75z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.091 441.971v37.3c0 5.595-4.536 10.131-10.131 10.131h110.52c15.09 0 27.323-12.233 27.323-27.323v-20.108c0-3.645-2.955-6.6-6.6-6.6h-114.511c-3.646 0-6.601 2.955-6.601 6.6z",
    fill: "url(#SVGID_14_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceSelection);
export default __webpack_public_path__ + "static/media/source-selection.f20c4d1c4747fb874f460e2b57b136ea.svg";
export { ForwardRef as ReactComponent };